/* eslint-disable*/
import http from './http'


export default {
    // ########################################################################
    // ########                                                     ###########
    // ########                       微信分享                       ###########
    // ########                                                     ###########
    // ########################################################################
    wxShare(params, response) {
        http.post(`/api/wechat/get_signature`, params, res => {
            return response(res);
        })
    },





    // ########################################################################
    // ########                                                     ###########
    // ########                       短信管理                       ###########
    // ########                                                     ###########
    // ########################################################################
    getSmsList(params, response) {
        http.post(`/api/sms/get_sms_list`, params, res => {
            return response(res);
        })
    },

    createSMS(params, response) {
        http.post(`/api/sms/create_sms`, params, res => {
            return response(res);
        })
    },


    // ########################################################################
    // ########                                                     ###########
    // ########                       七牛文件管理                   ###########
    // ########                                                     ###########
    // ########################################################################
    getQiniuFileList(params, response) {
        http.post(`/api/qiniu/get_file_list`, params, res => {
            return response(res);
        })
    },


    // ########################################################################
    // ########                                                     ###########
    // ########                       案例集管理                       ###########
    // ########                                                     ###########
    // ########################################################################


    // list
    getCategoryList(params, response) {
        http.get(`/api/article/get_category_list`, params, res => {
            return response(res);
        })
    },
    getSubCategoryList(params, response) {
        http.get(`/api/article/get_subcategory_list`, params, res => {
            return response(res);
        })
    },
    getArticleList(params, response) {
        http.get(`/api/article/get_article_list`, params, res => {
            return response(res);
        })
    },
    getBannerList(params, response) {
        http.get(`/api/article/get_banner_list`, params, res => {
            return response(res);
        })
    },
    getContactList(params, response) {
        http.get(`/api/article/get_contact_list`, params, res => {
            return response(res);
        })
    },

    // detail
    getArticleDetail(params, response) {
        http.get(`/api/article/get_article_detail`, params, res => {
            return response(res);
        })
    },

    // create
    createCategory(params, response) {
        http.post(`/api/article/create_category`, params, res => {
            return response(res);
        })
    },
    createSubCategory(params, response) {
        http.post(`/api/article/create_subcategory`, params, res => {
            return response(res);
        })
    },
    createArticle(params, response) {
        http.post(`/api/article/create_article`, params, res => {
            return response(res);
        })
    },
    createBanner(params, response) {
        http.post(`/api/article/create_banner`, params, res => {
            return response(res);
        })
    },
    createContact(params, response) {
        http.post(`/api/article/create_contact`, params, res => {
            return response(res);
        })
    },


    // update
    updateCategory(params, response) {
        http.post(`/api/article/update_category`, params, res => {
            return response(res);
        })
    },
    updateSubCategory(params, response) {
        http.post(`/api/article/update_subcategory`, params, res => {
            return response(res);
        })
    },
    updateArticle(params, response) {
        http.post(`/api/article/update_article`, params, res => {
            return response(res);
        })
    },
    updateBanner(params, response) {
        http.post(`/api/article/update_banner`, params, res => {
            return response(res);
        })
    },
    updateContact(params, response) {
        http.post(`/api/article/update_contact`, params, res => {
            return response(res);
        })
    },

    // delete
    deleteCategory(params, response) {
        http.post(`/api/article/delete_category`, params, res => {
            return response(res);
        })
    },
    deleteSubCategory(params, response) {
        http.post(`/api/article/delete_subcategory`, params, res => {
            return response(res);
        })
    },
    deleteArticle(params, response) {
        http.post(`/api/article/delete_article`, params, res => {
            return response(res);
        })
    },
    deleteBanner(params, response) {
        http.post(`/api/article/delete_banner`, params, res => {
            return response(res);
        })
    },
    deleteContact(params, response) {
        http.post(`/api/article/delete_contact`, params, res => {
            return response(res);
        })
    },


    // ########################################################################
    // ########                                                     ###########
    // ########                       用户管理                       ###########
    // ########                                                     ###########
    // ########################################################################
    isOnline(params, response) {
        http.get(`/api/admin/isOnline`, params, res => {
            return response(res);
        })
    },
    // 登录系统
    login(params, response) {
        http.post(`/api/admin/login`, params, res => {
            return response(res);
        })
    },
    // 退出系统
    logout(params, response) {
        http.post(`/api/admin/logout`, params, res => {
            return response(res);
        })
    },
    // 修改密码
    updatePassword(params, response) {
        http.post(`/api/admin/update_password`, params, res => {
            return response(res);
        })
    },
    // 获取权限
    getPermissionList(params, response) {
        http.get(`/api/admin/get_permission_list`, params, res => {
            return response(res);
        })
    },
    // 获取组
    getSystemGroupList(params, response) {
        http.get(`/api/admin/get_group_list`, params, res => {
            return response(res);
        })
    },
    // 创建组
    createSystemGroup(params, response) {
        http.post(`/api/admin/create_group`, params, res => {
            return response(res);
        })
    },
    // 更新组
    updateSystemGroup(params, response) {
        http.post(`/api/admin/update_group`, params, res => {
            return response(res);
        })
    },
    // 获取当前管理员信息
    getManagerInfo(params, response) {
        http.get(`/api/admin/getManagerInfo`, params, res => {
            return response(res);
        })
    },
    // 获取管理员列表
    getSystemManagerList(params, response) {
        http.get(`/api/admin/get_manager_list`, params, res => {
            return response(res);
        })
    },
    // 创建管理员
    createSystemManager(params, response) {
        http.post(`/api/admin/create_manager`, params, res => {
            return response(res);
        })
    },
    // 更新管理员
    updateSystemManager(params, response) {
        http.post(`/api/admin/update_manager`, params, res => {
            return response(res);
        })
    },
}